module.exports = __webpack_public_path__ + "img/ic_typing_round.92e98e7e.svg";